import { render, staticRenderFns } from "./CbxHealthStatus.vue?vue&type=template&id=1ed12ea6&"
import script from "./CbxHealthStatus.vue?vue&type=script&lang=ts&"
export * from "./CbxHealthStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports